import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import CryptoJS from "crypto-js";
import queryString from "query-string";
import constants from "../../../../utils/constants";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { useHistory } from "react-router-dom";
import "../../../../common/style/main.css";
import { verifyingEmail } from "./../../reducer/actions";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ContentWrapper from "../../../../common/components/contentWrapper";

const EmailVerify = () => {
  const history = useHistory();
  const [verifying, setVerifying] = useState(true);
  const [isSuccess, setIsSuccess] = useState(null);
useEffect(() => {
  const verifyUser = () => {
    try {
      const parsed = queryString.parse(window.location.search);
      let uuid = parsed?.uuid || "";

      let decryptedEmail = "";

      if (uuid) {
        try {
          uuid = decodeURIComponent(uuid);
          uuid = uuid.replace(/ /g, "+");

          const bytes = CryptoJS.AES.decrypt(
            uuid,
            constants.EMAIL_SECERETKEY
          );

          decryptedEmail = bytes.toString(CryptoJS.enc.Utf8);
        } catch (err) {
          console.error("Decryption failed:", err);
        }
      }

      if (!decryptedEmail) {
        setIsSuccess(false);
        setVerifying(false);
        return;
      }

      const payload = {
        email: decryptedEmail,
      };

      verifyingEmail(payload, (err, res) => {
        // console.log("API:", res);

        if (err) {
          setIsSuccess(false);
        } else {
          const success =
            res?.success === true ||
            res?.success === 1 ||
            res?.data?.success === true;

          setIsSuccess(success);
        }

        setVerifying(false);
      });
    } catch (err) {
      console.error(err);
      setIsSuccess(false);
      setVerifying(false);
    }
  };

  verifyUser();
}, []);

  if (verifying) {
    return (
      <Container maxWidth="sm">
        <Box
          minHeight="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={2}
        >
          <CircularProgress />
          <Typography variant="h6">Verifying...</Typography>
        </Box>
      </Container>
    );
  }

  const contentView = (
    <Container maxWidth="sm">
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Card elevation={3} sx={{ width: "100%", borderRadius: 3 }}>
          <CardContent>
            <Stack spacing={3} alignItems="center">

              {isSuccess && (
                <>
                  <MarkEmailReadOutlinedIcon
                    color="success"
                    sx={{ fontSize: 60 }}
                  />

              <Typography variant="h6" fontWeight="bold">
                Email Verified Successfully
              </Typography>

              <p className="success-activate">
                Your account has been successfully activated. Log in now and experience WatchOps!
              </p>

              <Button
                variant="contained"
                size="large"
                onClick={() => history.push("/login")}
                className="SubmitColor space-m-1"
              >
                Go to Login
              </Button>
              </>
              )}

              {!isSuccess && (
                <>
                  <ErrorOutlineIcon
                    color="error"
                    sx={{ fontSize: 70, mb: 2 }}
                  />
                  <Typography variant="h6" color="error">
                    Invalid Verification Link
                  </Typography>

                  <p align="center" style={{ fontSize: "16px", color: '#000' }}>
                      This verification link is no longer valid or has expired. Please contact your administrator.                  </p>
                </>
              )}
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
  return <ContentWrapper contentView={contentView} />;
};

export default EmailVerify;
